import { render } from "./createTeam.vue?vue&type=template&id=2bf9e7ca&scoped=true"
import script from "./createTeam.vue?vue&type=script&lang=js"
export * from "./createTeam.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createTeam.vue?vue&type=style&index=1&id=2bf9e7ca&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf9e7ca"]])

export default __exports__